import { render, staticRenderFns } from "./GlobalPartnerDetail.vue?vue&type=template&id=3b50e334&scoped=true"
import script from "./GlobalPartnerDetail.vue?vue&type=script&lang=js"
export * from "./GlobalPartnerDetail.vue?vue&type=script&lang=js"
import style0 from "./GlobalPartnerDetail.vue?vue&type=style&index=0&id=3b50e334&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b50e334",
  null
  
)

export default component.exports